/*** IMPORTS FROM imports-loader ***/
(function() {

define([
  'jquery',
  'javascript-debounce',
  'mustache',
  'pip-model',
  'pip-events',
  'workwear',
  'pip-media-manager',
  'pip-common.utils',
  'plugin.tooltip',
  'paint-image-map',
  'paint-modals'
],
function (
  $,
  debounce,
  Mustache,
  pip,
  pipEvents,
  workwear,
  pipMediaManager,
  pipCommonUtils,
  tooltip,
  paintImageMap,
  paintModals
) {
	var KEY_VALUE_DELIMITER = '::';
	var COMBINATION_DELIMITER = '~~';
	var MAXIMUM_COMBINATIONS_FOR_PRICE_ENDPOINT = 25;
  var PAINT_RGB_GUID = 'd3aaa2df-e13a-4f76-a06f-dddaeda235e5';
  var PAINT_BRAND_GUID = 'a6b3fd35-901f-4506-afaf-8b798895f64c';

	var view = {
		selectors: {
			pip: '#pipContainer',
      spinnerOverlay: '.super-sku__spinner-overlay',
			inline: {
				wrapper: {
					default: '.super-sku__inline-tile-wrapper:not(.super-sku__inline-tile-wrapper--super-duper-sku, .history)',
				},
				ssku: {
					launchOverlay: '.launch-overlay-wrapper',
					launchOverlayHidden: 'launch-overlay-wrapper--hidden',
					mainWrapper: '.super-sku__inline:not(.super-sku__inline--super-duper-sku)',
					selectedTile: '.super-sku__inline-tile--selected',
					selectedSwatch: '.super-sku__inline-swatch--selected',
          selectedDropdownItem: '.super-sku__inline-dropdown-item--selected',
          selectedElement: '.super-sku__inline-swatch--selected, .super-sku__inline-tile--selected, .super-sku__inline-card--selected',
          dropdownSection: '.super-sku__inline-dropdown-section',
          swatchLoadingImage: '.super-sku__inline-card__loading-image',
          availableCard: '.super-sku__inline-card:not(.super-sku__inline-card--selected):not(.super-sku__inline-card--history)',
					availableTile: '.super-sku__inline-tile:not(.super-sku__inline-tile--selected):not(.super-sku__inline-tile--super-duper-sku)',
					availableSwatch: '.super-sku__inline-swatch:not(.super-sku__inline-swatch--selected)',
          tile: '.super-sku__inline-tile:not(.super-sku__inline-tile--super-duper-sku)',
					swatch: '.super-sku__inline-swatch',
          availableDropdownItem: '.super-sku__inline-dropdown-item:not(.super-sku__inline-dropdown-item--selected)',
          availableElement: function() {
            return view.selectors.inline.ssku.availableCard + ', ' + view.selectors.inline.ssku.availableTile + ', ' + view.selectors.inline.ssku.availableDropdownItem + ', ' + view.selectors.inline.ssku.availableSwatch;
          },
          availableSwatchWithId: function(itemId) {
            return view.selectors.inline.ssku.availableSwatch +'[data-itemid="' + itemId + '"], ' + view.selectors.inline.ssku.availableTile +'[data-itemid="' + itemId + '"]'
          },
          elementWithId: function(itemId) {
            return view.selectors.inline.ssku.swatch +'[data-itemid="' + itemId + '"], ' + view.selectors.inline.ssku.tile +'[data-itemid="' + itemId + '"]'
          }
				},
        sdsku: {
          mainContainer: '.super-sku__inline.super-sku__inline--super-duper-sku',
          availableTile: '.super-sku__inline-tile--super-duper-sku:not(.super-sku__inline-tile--selected)'
        },
			},
      history: {
        card: '.super-sku__inline-card--history',
        wrapper: '.super-sku__inline-tile-wrapper.history:not(.super-sku__inline-tile-wrapper--super-duper-sku)'
      },
      tooltip: {
        swatchTooltip: '.super-sku__inline-swatch-tooltip',
        wrapper: '.ToolTip__wrapper',
        outerWrapper: '.ToolTip'
      },
			overlay: {
				wrapper: '.ssku-overlay-content-wrapper',
				icon: '.super-sku__overlay-header-pip-icons',
        ssku: {
          availableTile: '.super-sku__overlay-tile:not(.super-sku__overlay-tile--selected)',
					availableSwatch: '.super-sku__overlay-swatch:not(.super-sku__overlay-swatch--selected)',
          availableSwatchOrAvailableTile: function() {
            return view.selectors.overlay.ssku.availableTile + ', ' + view.selectors.overlay.ssku.availableSwatch
          }
        },
				options: {
					contents: '.super-sku__overlay-options-container-body',
					container: '.super-sku__overlay-options-container',
					selected: '.super-sku__overlay-super-sku-tile--selected'
				},
				footer: {
					apply: '.super-sku__overlay-footer-apply',
					price: '.super-sku__overlay-footer-price-container'
				}
			},
      shared: {
        attributeLabel: '[data-attributename]'
      }
		},
    //TODO: ssku dropdowns use a mix of global css and pip overrides so some classnames cannot be messed with
    // the real task here is to make sure I delete this comment during the code review process after enough people
    // are aware of this totally interesting fact.
		classes: {
      hiddenSpinnerOverlay: 'super-sku__spinner-overlay--hidden',
			inline : {
				wrapper: {
					hidden: 'super-sku__inline-tile-wrapper--hidden'
				},
				ssku: {
          loadingImage: 'super-sku__inline-card__loading-image',
          activeDropdown: 'active',
					launchOverlayHidden :'launch-overlay-wrapper--hidden',
					mainWrapperLoading: 'super-sku__inline--loading',
					visible: 'super-sku__inline-tile--visible',
				}
			},
      overlay: {
        containerWithFade: 'super-sku__overlay__options-container--with-fade'
      },
      tooltip: {
        wrapperOverride: 'ToolTip__wrapper--ssku-hover'
      }
		},
		templates: {
			inline: {
        mainOptions: $('#super-sku__main-options').html(),
        configurableDisplay: {
          card: {
            container: $('#super-sku__standard-card-container').html(),
            dominant: $('#super-sku__dominant-card').html(),
          },
          swatch: {
            container: $('#super-sku__standard-swatch-container').html(),
            dominant: $('#super-sku__dominant-swatch').html(),
            recessive: $('#super-sku__recessive-swatch').html()
          },
          tile: {
            container: $('#super-sku__standard-tile-container').html(),
            dominant: $('#super-sku__dominant-tile').html(),
            recessive: $('#super-sku__recessive-tile').html()
          },
          dropdown: {
            container: $('#super-sku__standard-dropdown-container').html(),
            dominant: $('#super-sku__dominant-dropdown').html(),
            recessive: $('#super-sku__recessive-dropdown').html()
          },
          swatchdropdown: {
            container: $('#super-sku__swatch-dropdown-container').html(),
            dominant: $('#super-sku__dominant-swatch-dropdown').html(),
            recessive: $('#super-sku__recessive-swatch-dropdown').html()
          },
          paint: {
            spinnerOverlay: $('#super-sku__spinner-overlay').html(),
            paintType: $('#super-sku__paint-type').html(),
            paintTypeContainer: $('#super-sku__paint-type-container').html(),
            brandName: $('#super-sku__brand-name').html(),
            brandNameContainer: $('#super-sku__brand-name-container').html(),
            sheen: $('#super-sku__sheen').html(),
            sheenContainer: $('#super-sku__sheen-container').html(),
            containerSize: $('#super-sku__container-size').html(),
            containerSizeContainer: $('#super-sku__container-size-container').html(),
          }
        },
        mainOptionsLoading: $('#super-sku__main-options-loading').html(),
				loadingError: $('#super-sku__loading-error').html(),
    		sdskuOptions: $('#sdsku__options').html(),
    		sskuTooltip: $('#ssku__tooltip').html(),
        sskuTooltipLegacy: $('#ssku__tooltip__legacy').html()
			},
      historicalSkuCard: $('#super-sku__historical-card').html(),
			overlay: {
				contents: $('#super-sku__overlay').html(),
				options: $('#super-sku__overlay-options').html(),
				price: $('#super-sku__overlay-price').html()
			}
		},
    tooltips: [],
		render: {
      mainOptions: function renderInlineMainOptions() {
        return Mustache.render(view.templates.inline.mainOptions, viewModel, {
          sskuStandardCardContainer: view.templates.inline.configurableDisplay.card.container,
          sskuDominantCard: view.templates.inline.configurableDisplay.card.dominant,
          sskuStandardDropdownContainer: view.templates.inline.configurableDisplay.dropdown.container,
          sskuDominantDropdown: view.templates.inline.configurableDisplay.dropdown.dominant,
          sskuRecessiveDropdown: view.templates.inline.configurableDisplay.dropdown.recessive,
          sskuStandardSwatchContainer: view.templates.inline.configurableDisplay.swatch.container,
          sskuDominantSwatch: view.templates.inline.configurableDisplay.swatch.dominant,
          sskuRecessiveSwatch: view.templates.inline.configurableDisplay.swatch.recessive,
          sskuStandardTileContainer: view.templates.inline.configurableDisplay.tile.container,
          sskuDominantTile: view.templates.inline.configurableDisplay.tile.dominant,
          sskuRecessiveTile: view.templates.inline.configurableDisplay.tile.recessive,
          sskuSwatchDropdownContainer: view.templates.inline.configurableDisplay.swatchdropdown.container,
          sskuDominantSwatchDropdown: view.templates.inline.configurableDisplay.swatchdropdown.dominant,
          sskuRecessiveSwatchDropdown: view.templates.inline.configurableDisplay.swatchdropdown.recessive,
          sskuHistoricalSku: view.templates.historicalSkuCard,
          sskuPaintType: view.templates.inline.configurableDisplay.paint.paintType,
          sskuPaintTypeContainer: view.templates.inline.configurableDisplay.paint.paintTypeContainer,
          sskuBrandName: view.templates.inline.configurableDisplay.paint.brandName,
          sskuBrandNameContainer: view.templates.inline.configurableDisplay.paint.brandNameContainer,
          sskuSheen: view.templates.inline.configurableDisplay.paint.sheen,
          sskuSheenContainer: view.templates.inline.configurableDisplay.paint.sheenContainer,
          sskuContainerSize: view.templates.inline.configurableDisplay.paint.containerSize,
          sskuContainerSizeContainer: view.templates.inline.configurableDisplay.paint.containerSizeContainer
        });
      },
      mainOptionsLoading: function renderInlineMainOptionsLoading() {
				return Mustache.render(view.templates.inline.mainOptionsLoading);
			},
			overlay: function renderOverlay() {
				return Mustache.render(view.templates.overlay.contents, viewModel.displayData);
			},
			options: function renderOverlayOptions() {
				return Mustache.render(view.templates.overlay.options, viewModel.displayData);
			},
			price: function renderOverlayPrice() {
				return Mustache.render(view.templates.overlay.price, viewModel.overlayPrice);
			},
			loadingError: function renderInlineLoadingError() {
				return Mustache.render(view.templates.inline.loadingError, {});
			},
      sdskuOptions: function renderSdskuOptions() {
        return Mustache.render(view.templates.inline.sdskuOptions, viewModel.sdsku);
      },
      sskuTooltip: function renderSskuTooltip(data) {
        if(shouldDisplayScaledTooltips()){
          return Mustache.render(view.templates.inline.sskuTooltip, data);
        }
        return Mustache.render(view.templates.inline.sskuTooltipLegacy, data);
      }
		},
		updateDom: {
      mainWrapper: function updateDomMainWrapper() {
				$(view.selectors.inline.ssku.mainWrapper).html(view.render.mainOptions).removeClass(view.classes.inline.ssku.mainWrapperLoading);
			},
      mainWrapperLoading: function updateDomMainWrapperLoading() {
				$(view.selectors.inline.ssku.mainWrapper).html(view.render.mainOptionsLoading).addClass(view.classes.inline.ssku.mainWrapperLoading);
			},
      sdskuMainContainer: function updateSdskuMainContainer() {
        $(view.selectors.inline.sdsku.mainContainer).html(view.render.sdskuOptions);
      },
			loadingError: function updateDomLoadingError() {
				$(view.selectors.inline.ssku.mainWrapper).html(view.render.loadingError);
			},
			removeSsku: function updateDomRemoveSsku() {
				$(view.selectors.inline.ssku.mainWrapper).empty();
			},
      removeSdsku: function updateDomRemoveSdsku() {
				$(view.selectors.inline.sdsku.mainContainer).empty();
			},
			openOverlay: function updateDomOpenOverlay() {
				$(view.selectors.pip).append(view.render.overlay);
				$(view.selectors.overlay.wrapper).append(view.render.options);
        view.updateDom.adjustMobileOverlaySectionsForOverflow();
        view.registerWindowResizeEvent();
        $(view.selectors.overlay.options.container).scroll(function (e) {
          $(this).removeClass(view.classes.overlay.containerWithFade);
        });
			},
			updateOverlay: function updateDomUpdateOverlay() {
				$(view.selectors.overlay.wrapper).html(view.render.options);
			},
			overlayPrice: function updateDomOverlayPrice() {
				$(view.selectors.overlay.footer.price).html(view.render.price);
			},
      //TODO: use a thd-overlay method instead of grayout remove
      //TODO: actually we're just going to delete this soon instead.
			removeOverlay: function updateDomRemoveOverlay() {
				$('.ssku-overlay').remove();
				$('#grayout').remove();
        $(window).off('.sskuOverlay');
			},

      toggleSpinnerOverlay: function toggleSpinnerOverlay() {
        $(view.selectors.spinnerOverlay).toggleClass(view.classes.hiddenSpinnerOverlay);
      },

      resetOverflowSections: function updateDomResetOverflowSections() {
        if (viewModel.displayData.definingAttributes.reduce(function(anyTileWithDropdownOverflow, definingAttribute) {
          return anyTileWithDropdownOverflow || (definingAttribute.displayConfig && (definingAttribute.displayConfig.tileWithDropdownOverflow || definingAttribute.displayConfig.swatchWithDropdownOverflow) && definingAttribute.displayConfig.isOverflowSection)
        }, false)) {
          viewModel.displayData.definingAttributes = viewModel.displayData.definingAttributes.map(function(definingAttribute) {
            definingAttribute.displayConfig.isOverflowSection = false;
            return definingAttribute;
          });
          view.updateDom.mainWrapper();
        }
      },
      //TODO: these functions can get a decent amount of cleanup once we get rid of the swatch limit FS.
      // should be able to get rid of the entire overlay at that point.
      adjustSectionsForOverflow: function updateDomAdjustSectionsForOverflow() {
        view.updateDom.overflowTilesAsDropdowns();
        view.updateDom.overflowTilesWithViewAll();
			},
      overflowTilesAsDropdowns: function updateDomOverflowTilesAsDropdowns() {
        view.updateDom.resetOverflowSections();
				var attributeSections = $(view.selectors.inline.wrapper.default);
				var selectedAttributeElements = $(view.selectors.inline.ssku.selectedElement);
        var shouldForceAnyDropdowns = false;

				attributeSections.each(function (index) {
					var attributeSection = $(this);
          var attributeIndex = $(this).data('attributeindex');
					var selectedAttributeElement = selectedAttributeElements.eq(index);
					var isOverflowSection = (attributeSections.eq(index).prop('scrollHeight') > attributeSections.eq(index).outerHeight(true));
          var displayConfig = viewModel.displayData.definingAttributes[attributeIndex].displayConfig;

          shouldForceAnyDropdowns = shouldForceAnyDropdowns || (isOverflowSection && (displayConfig.tileWithDropdownOverflow || displayConfig.swatchWithDropdownOverflow));
          viewModel.displayData.definingAttributes[attributeIndex].displayConfig.isOverflowSection = isOverflowSection;
				});
        //TODO: find a way to optimize this. shouldForceAnyDropdowns is not sufficient for initial page load on non-dropdowns.
        if (shouldForceAnyDropdowns) {
          view.updateDom.mainWrapper();
        }
      },
      overflowTilesWithViewAll: function updateDomOverflowTilesWithViewAll() {
				var attributeSections = $(view.selectors.inline.wrapper.default);
				var selectedAttributeElements = $(view.selectors.inline.ssku.selectedElement);
				var launchOverlayWrappers = $(view.selectors.inline.ssku.launchOverlay);

				attributeSections.each(function (index) {
					var attributeSection = $(this);
          var attributeIndex = attributeSection.data('attributeindex');
					var selectedAttributeElement = selectedAttributeElements.eq(index);
					var isOverflowSection = view.updateDom.isOverflowSection(attributeSections.eq(index));
          var displayConfig = viewModel.displayData.definingAttributes[attributeIndex].displayConfig;

          viewModel.displayData.definingAttributes[attributeIndex].displayConfig.isOverflowSection = isOverflowSection;

          if (isOverflowSection) {
            if (displayConfig.standardTile || displayConfig.standardSwatch) {
              view.updateDom.scrollToSelectedElement(attributeSection, selectedAttributeElement);
              launchOverlayWrappers.eq(index).toggleClass(view.classes.inline.ssku.launchOverlayHidden, !isOverflowSection);
            }
            if (displayConfig.standardCard) {
              view.updateDom.horizontalScrollToSelectedElement(attributeSection, selectedAttributeElement);
            }
          }
				});
      },
      saveCurrentScrollState: function updateDomSaveCurrentScrollState() {
				var attributeSections = $(view.selectors.inline.wrapper.default);
				var selectedAttributeElements = $(view.selectors.inline.ssku.selectedElement);

				attributeSections.each(function (index) {
					var attributeSection = $(this);
          var attributeIndex = attributeSection.data('attributeindex');
					var selectedAttributeElement = selectedAttributeElements.eq(index);

          viewModel.scrollStates[attributeIndex] = {
            top: attributeSection.scrollTop() || 0,
            left: attributeSection.scrollLeft() || 0
          }
				});
      },
      restorePreviousScrollState: function updateDomRestorePreviousScrollState() {
        var attributeSections = $(view.selectors.inline.wrapper.default);
				var selectedAttributeElements = $(view.selectors.inline.ssku.selectedElement);

				attributeSections.each(function (index) {
					var attributeSection = $(this);
          var attributeIndex = attributeSection.data('attributeindex');
					var selectedAttributeElement = selectedAttributeElements.eq(index);
          var scroll = viewModel.scrollStates[attributeIndex];
          if (scroll) {
            attributeSection.scrollTop(scroll.top);
            attributeSection.scrollLeft(scroll.left);
          }
				});
      },
      // TODO: move during swatch card cleanup
      isOverflowSection: function isOverflowSection(section) {
        return !!(section.prop('scrollHeight') > section.outerHeight(true) || section.prop('scrollWidth') > section.outerWidth(true))
      },
      adjustMobileOverlaySectionsForOverflow: function updateDomAdjustMobileOverlaySectionsForOverflow() {
        $(view.selectors.overlay.options.container).each(function () {
					var isOverflowSection = (($(this).prop('scrollHeight') - parseInt($(this).css('padding-bottom').replace('px', ''))) > $(this).outerHeight(true));
					$(this).toggleClass(view.classes.overlay.containerWithFade, isOverflowSection);
				});
			},
			scrollToSelectedElement: function updateDomScrollToSelectedElement(nodeSection, selectedElement) {
        if (viewModel.impossibleState) {
          return;
        }
        var nodeSectionTop = nodeSection.offset().top  - parseInt(nodeSection.css('padding-top').replace('px', ''));
				var nodeSectionBottom = nodeSectionTop + nodeSection.outerHeight(true);
				var selectedTop = selectedElement.offset().top - parseInt(selectedElement.css('padding-top').replace('px', '')) - parseFloat(selectedElement.css('border-top-width').replace('px', ''));
				var selectedBottom = selectedTop + selectedElement.outerHeight(true);

				if (selectedBottom > nodeSectionBottom) {
					nodeSection.scrollTop(nodeSection.scrollTop() + selectedBottom - nodeSectionBottom);
				}
			},
      horizontalScrollToSelectedElement: function updateDomHorizontalScrollToSelectedElement(nodeSection, selectedElement) {
        if (viewModel.impossibleState) {
          return;
        }
        var nodeSectionLeft = nodeSection.offset().left  - parseInt(nodeSection.css('padding-left').replace('px', ''));
				var nodeSectionRight = nodeSectionLeft + nodeSection.outerWidth(true);
				var selectedLeft = selectedElement.offset().left - parseInt(selectedElement.css('padding-left').replace('px', '')) - parseFloat(selectedElement.css('border-left-width').replace('px', ''));
				var selectedRight = selectedLeft + selectedElement.outerWidth(true);

				if (selectedRight > nodeSectionRight) {
					nodeSection.scrollLeft(nodeSection.scrollLeft() + selectedRight - nodeSectionRight);
				}
			}
		},
    registerWindowResizeEvent: function registerWindowResizeEvent() {
      $(window).off('.sskuOverlay');
      $(window).on('resize.sskuOverlay', function (e) {
        debounce(view.updateDom.adjustMobileOverlaySectionsForOverflow(), 250);
      });
    },
    createTooltips: function createTooltips() {
      if(pip.platform === 'MOBILE') {
        return;
      }
  		view.tooltips = [];
      $(view.selectors.tooltip.swatchTooltip).closest(view.selectors.tooltip.outerWrapper).remove();
      viewModel.displayData.definingAttributes.forEach(function(definingAttribute, index) {
        definingAttribute.attributes.forEach(function(attribute) {
            var tooltipSelector = $(view.selectors.inline.ssku.elementWithId(attribute.itemId));
            var tooltipConfig = {
               content: view.render.sskuTooltip(attribute),
               position: 'top',
               width: 'ssku-hover' //TODO: this hack is due to limitations of outdated global tooltips
             };
            if (!tooltipSelector || !attribute.image) {
              return;
            }
            if (tooltipSelector.length === 1) {
              view.tooltips.push(tooltipSelector.tooltip(tooltipConfig));
            }
            if (tooltipSelector && attribute.image && tooltipSelector.length >= 2) {
              view.tooltips.push(tooltipSelector.eq(index).tooltip(tooltipConfig));
            }
          })
      });
  	},

		initEventListeners: function initEventListeners() {
			$(window.document).off('.ssku');

			$(window.document).on('click.ssku', (view.selectors.inline.ssku.availableElement()), function (e) {
				e.preventDefault();
				var attributeLabel = $(this).closest(view.selectors.shared.attributeLabel);

				var clickedTileInformation = {
					attributeLabel: $(attributeLabel).attr('data-attributename'),
					attributeValue: helperFunctions.getUnMinifiedString($(this).data('tilemessaging'))
				}

				var newSelectedState = helperFunctions.createSelectedState(clickedTileInformation);
				var attributeCombination = newSelectedState.map(function (selectedAttribute) {
					return selectedAttribute.attributeValue;
				}).join(COMBINATION_DELIMITER);
        if (shouldDisplayHistoricalCards()) {
		      viewModel.updateHistoricalSkuQueue(viewModel.selectedAttributes, attributeCombination);
        }
        view.updateDom.saveCurrentScrollState();
				viewModel.set.jumpedState(!viewModel.checkCombination(newSelectedState));
        viewModel.set.impossibleState(false);
        viewModel.set.selectedAttributes(viewModel.getSelectedAttributes(newSelectedState, clickedTileInformation));
        viewModel.set.selectedProductInformation(viewModel.getProductInformation());
        if(!viewModel.jumpedState && !viewModel.impossibleState) {
          viewModel.set.unavailableState(!viewModel.selectedProductInformation.isAvailable);
        }
				viewModel.set.displayData(viewModel.getDisplayData());
			  view.updateDom.mainWrapper();
        if(shouldUseSwatchCards()) {
          view.handleLoadingImages();
        }
        view.updateDom.restorePreviousScrollState();
        view.updateDom.adjustSectionsForOverflow();
        view.updateDom.saveCurrentScrollState();
				helperFunctions.getSskuProductPage();
        pipEvents.ssku.sskuInteraction.trigger();
			});

			$(window.document).on('click.ssku', view.selectors.history.card, function (e) {
				e.preventDefault();
        //TODO: translate all of our data tags for ssku into kebab case.
				var attributeCombination = $(this).data('attributecombination');
				if (!attributeCombination) {
					return;
				}
				attributeCombination = helperFunctions.getUnMinifiedString(attributeCombination);
				var attributeValues = attributeCombination.split(COMBINATION_DELIMITER);
        if (shouldDisplayHistoricalCards()) {
          viewModel.updateHistoricalSkuQueue(viewModel.selectedAttributes, attributeCombination);
        }
				viewModel.selectedAttributes = viewModel.selectedAttributes.map(function (selectedAttribute, index) {
					selectedAttribute.attributeValue = attributeValues[index];
					return selectedAttribute;
				});

				viewModel.set.jumpedState(false);
				viewModel.set.selectedProductInformation(viewModel.getProductInformation());
        if(!viewModel.jumpedState && !viewModel.impossibleState) {
          viewModel.set.unavailableState(!viewModel.selectedProductInformation.isAvailable);
        }
				viewModel.set.displayData(viewModel.getDisplayData());
				view.updateDom.mainWrapper();
        view.updateDom.restorePreviousScrollState();
        view.updateDom.adjustSectionsForOverflow();
        view.updateDom.saveCurrentScrollState();
				helperFunctions.getSskuProductPage();
			});

			$(window.document).on('click.ssku', (view.selectors.overlay.ssku.availableSwatchOrAvailableTile()), function (e) {
				e.preventDefault();

				var clickedTileInformation = {
					attributeLabel: $(this).closest(view.selectors.shared.attributeLabel).data('attributename'),
					attributeValue: helperFunctions.getUnMinifiedString($(this).data('tilemessaging'))
				}
				var newSelectedState = helperFunctions.createSelectedState(clickedTileInformation);

				viewModel.set.jumpedState(!viewModel.checkCombination(newSelectedState));
        viewModel.set.impossibleState(false);
				viewModel.set.selectedAttributes(viewModel.getSelectedAttributes(newSelectedState, clickedTileInformation));
				viewModel.set.selectedProductInformation(viewModel.getProductInformation());
				viewModel.set.displayData(viewModel.getDisplayData());
				view.updateDom.updateOverlay();
				viewModel.updateOverlayPrice();
			});

			$(window.document).on('click.ssku', view.selectors.inline.ssku.launchOverlay, function (e) {
				e.preventDefault();
				view.updateDom.openOverlay();
				viewModel.updateOverlayPrice();
			});

			$(window.document).on('click.ssku', view.selectors.overlay.icon, function (e) {
				e.preventDefault();
				view.updateDom.removeOverlay();
        view.updateDom.adjustSectionsForOverflow();
			});

			$(window.document).on('click.ssku', view.selectors.overlay.footer.apply, function (e) {
				e.preventDefault();
			  view.updateDom.mainWrapper();
				view.updateDom.removeOverlay();
        view.updateDom.adjustSectionsForOverflow();
				helperFunctions.getSskuProductPage();
        pipEvents.ssku.sskuInteraction.trigger();
      });

      $(window).on('resize.ssku', function (e) {
        debounce(view.updateDom.adjustSectionsForOverflow(), 250);
	    });

      $(document).off('.sskuDropdown').on('click.sskuDropdown', view.selectors.inline.ssku.dropdownSection, function(e) {
  			e.preventDefault();
  			e.stopPropagation();
        var isCurrentlyActive = $(this).hasClass(view.classes.inline.ssku.activeDropdown);
        $(view.selectors.inline.ssku.dropdownSection).removeClass(view.classes.inline.ssku.activeDropdown);
        if (!isCurrentlyActive) {
            $(this).addClass(view.classes.inline.ssku.activeDropdown);
        }
      });

  		$(document).off('.sskuClose').on('click.sskuClose', function(e) {
        $(view.selectors.inline.ssku.dropdownSection).removeClass(view.classes.inline.ssku.activeDropdown);
  		});

      $(window.document).off('.sdsku');
      $(window.document).on('click.sdsku', view.selectors.inline.sdsku.availableTile, function() {
        viewModel.sdsku.setSelectedData(viewModel.sdsku.getSelectedData($(this).attr('data')));
        view.updateDom.removeSdsku();
        view.updateDom.mainWrapperLoading();

        viewModel.sdsku.getCanonicalURL().done(function (response) {
          helperFunctions.getSdskuProductPage(response.canonicalURL);
        }).fail(function (error) {
          error.status >= 500 ? view.updateDom.loadingError() : view.updateDom.removeSsku();
          if (pip.debugMode) {
            console.error('Failed to load Super Duper Sku:', error);
          }
        });
      });
		},

    handleLoadingImages: function handleLoadingImages() {
      var removeLoadingStyle = function() {
        $(this).removeClass(view.classes.inline.ssku.loadingImage);
      };
      $(view.selectors.inline.ssku.swatchLoadingImage).each(function() {
        if( this.complete ) {
            removeLoadingStyle.call(this);
        } else {
            $(this).one('load', removeLoadingStyle);
        }
      });
    },

		init: function initView() {
		  view.updateDom.mainWrapper();
      if(shouldUseSwatchCards()) {
        view.handleLoadingImages();
      }
      view.updateDom.restorePreviousScrollState();
      view.updateDom.adjustSectionsForOverflow();
      view.updateDom.saveCurrentScrollState();
      if (viewModel.sdsku.isSdskuDisplayable()) {
        view.updateDom.sdskuMainContainer();
      }

      if (shouldDisplayTooltips()) {
        view.createTooltips();
      }

			view.initEventListeners();
			pipEvents.ssku.sskuRendered.trigger();
		}
	}

	var viewModel = {
    isPaint: false,
		displayData: {},
    scrollStates: [],
		selectedAttributes: [],
		jumpedState: false,
    impossibleState: false,
    unavailableState: false,
		selectedProductInformation: {
			itemId: '',
			canonicalUrl: ''
		},
		overlayPrice: {
			isLoading: true,
			price: {}
		},
		historicalSkuQueue: [],
  	attributeInjector: {},
    getAttributeMoreInfoHook: function getAttributeMoreInfoHook(attribute) {
      var hookName = attribute.toLowerCase().replace(/[^a-z]+/g,'');
      return viewModel.attributeInjector[hookName];
    },
		set: {
			selectedAttributes: function setSelectedAttributes(selectedAttributes) {
				viewModel.selectedAttributes = selectedAttributes;
			},
			displayData: function setDisplayData(displayData) {
				viewModel.displayData = displayData;
			},
			selectedProductInformation: function setSelectedProductInformation(productInformation) {
				viewModel.selectedProductInformation = productInformation;
			},
			jumpedState: function setJumpedState(jumpedState) {
				viewModel.jumpedState = jumpedState;
			},
      impossibleState: function setImpossibleState(impossibleState) {
				viewModel.impossibleState = impossibleState;
			},
      unavailableState: function setUnavailableState(unavailableState) {
        viewModel.unavailableState = unavailableState;
      },
			overlayPrice: function setOverlayPrice(updatedPrice) {
				viewModel.overlayPrice = {
					isLoading: !(updatedPrice),
					price: updatedPrice
				};
			}
		},
    initScrollStates: function initScrollStates() {
      viewModel.scrollStates = model.data.attributes.map(function() {
        return {top: 0, left: 0};
      })
    },
		determineSelectedAttributes: function determineSelectedAttributes(selected) {
			if (!!selected) {
				return viewModel.createSelectedItemAttributes(selected);
			}
      if (!model.data.childItemsLookup || model.data.childItemsLookup.length === 0) {
        view.updateDom.loadingError();
        return [];
      }
			var selectedProduct = model.data.childItemsLookup.filter(function (item) {
				return item.itemId === pip.products.primary.data.itemId;
			})
			if (selectedProduct.length === 0) {
        viewModel.set.impossibleState(true);
        view.updateDom.mainWrapper();
        return viewModel.createMissingSelectedItemAttributes(model.data.childItemsLookup[0].attributeCombination);
			}
			return viewModel.createSelectedItemAttributes(selectedProduct[0].attributeCombination);
		},
		createSelectedItemAttributes: function createSelectedItemAttributes(selectedItem) {
			var currentlySelected = selectedItem.split(COMBINATION_DELIMITER);
			return currentlySelected.map(function (attributeValue, index) {
				return {
					attributeLabel: model.data.attributes[index].attributeName,
					attributeLabelMinified: helperFunctions.getMinifiedString(model.data.attributes[index].attributeName),
					attributeValue: (attributeValue.indexOf(KEY_VALUE_DELIMITER) >= 0 ? attributeValue.split(KEY_VALUE_DELIMITER)[1] : attributeValue),
          swatch: model.data.attributes[index].swatch
				}
			});
		},
    createMissingSelectedItemAttributes: function createMissingSelectedItemAttributes(selectedItem) {
			var dummySelected = selectedItem.split(COMBINATION_DELIMITER);
			return dummySelected.map(function (attributeValue, index) {
				return {
					attributeLabel: model.data.attributes[index].attributeName,
					attributeLabelMinified: helperFunctions.getMinifiedString(model.data.attributes[index].attributeName),
					attributeValue: 'UNDEFINED'
				}
			});
		},
    addMediaAndPriceForSingleAttribute: function addMediaAndPriceForSingleAttribute(displayData) {
      displayData.definingAttributes[0].attributes = displayData.definingAttributes[0].attributes.map(function(attribute){
        var matchedItems = model.data.childItemsLookup.filter(function (childItem) {
          return attribute.attributeValue === childItem.attributeCombination;
        });
        if (matchedItems) {
          $.extend(attribute, matchedItems[0], {tooltipsEnabled: shouldDisplayTooltips()});
        }
        return attribute;
      });
    },
    addMediaAndPriceForMultipleAttributes: function addMediaAndPriceForMultipleAttributes(displayData, attributeCombinationDisplayMatrix) {
      displayData.definingAttributes.forEach(function (definingAttribute, attributeIndex) {
        definingAttribute.attributes.forEach(function (attribute, valueIndex) {
          if (pipCommonUtils.deepGet(attributeCombinationDisplayMatrix,  attributeIndex+'.'+valueIndex)) {
            model.data.childItemsLookup.forEach(function (childItem) {
              if (childItem.attributeCombination === attributeCombinationDisplayMatrix[attributeIndex][valueIndex]) {
                $.extend(attribute, childItem, {tooltipsEnabled: shouldDisplayTooltips()});
              }
            });
          }
        })
      });
    },
		combinatorial: {
			getDisplayData: function getCombinatorialDisplayData(displayData) {
        if (viewModel.impossibleState) {
          return viewModel.combinatorial.disableAttributes(displayData, model.data.attributes.map(function(attribute){return attribute.attributeValues}));
        }
				var combinationKeys = viewModel.combinatorial.getCombinationKeys();
				var possibleCombinations = viewModel.combinatorial.getAllPossibleCombinations(combinationKeys);
				var rankedCombinations = viewModel.combinatorial.rankPossibleCombinations(possibleCombinations);
				var uniqueCombinations = viewModel.combinatorial.getUniquePossibleCombinations(rankedCombinations);
				var disabledValues = viewModel.combinatorial.getDisabledValues(uniqueCombinations);

        if (shouldDisplayTooltips() || shouldUseSwatchCards() || shouldDisplayInventory()) {
          var attributeCombinationDisplayMatrix = viewModel.combinatorial.getAttributeCombinationDisplayMatrix(rankedCombinations);
          viewModel.addMediaAndPriceForMultipleAttributes(displayData, attributeCombinationDisplayMatrix)
        }

        var combinatorialDisplayData = viewModel.combinatorial.disableAttributes(displayData, disabledValues);

        if (pip.features.sskuDeadlockFixEnabled) {
          combinatorialDisplayData = viewModel.combinatorial.rectifyDeadlockOnDisplayData(combinatorialDisplayData);
        }

        return combinatorialDisplayData;

			},
      //TODO: these could be made into pure functions.
			getLastAttributeCombinationsKey: function getLastAttributeCombinationsKey() {
				return viewModel.selectedAttributes[viewModel.selectedAttributes.length - 1].attributeLabel + KEY_VALUE_DELIMITER + viewModel.selectedAttributes[viewModel.selectedAttributes.length - 1].attributeValue;
			},
			getUpperAttributesCombinationsKey: function getUpperAttributesCombinationsKey() {
				return viewModel.selectedAttributes.slice(0, -1).map(function (selected) {
					return selected.attributeLabel + KEY_VALUE_DELIMITER + selected.attributeValue;
				}).join(COMBINATION_DELIMITER);
			},
			getCombinationKeys: function getCombinationKeys() {
				return {
					upperAttributesCombinationsKey: viewModel.combinatorial.getUpperAttributesCombinationsKey(),
					lastAttributeCombinationsKey: viewModel.combinatorial.getLastAttributeCombinationsKey()
				}
			},
			getAllPossibleCombinations: function disabledGetAllPossibleCombinations(combinationKeys) {
				var possibleParents = model.data.attributeTreeLookupNodes[combinationKeys.lastAttributeCombinationsKey].parents.map(function (data) {
					return data + COMBINATION_DELIMITER + combinationKeys.lastAttributeCombinationsKey;
				});
				var possibleLastRow = model.data.attributeTreeLookupNodes[combinationKeys.upperAttributesCombinationsKey].children.map(function (data) {
					return combinationKeys.upperAttributesCombinationsKey + COMBINATION_DELIMITER + data;
				});
				return possibleParents.concat(possibleLastRow);
			},
			rankPossibleCombinations: function rankPossibleCombinations(possibleCombinations) {
				return helperFunctions.rankCombinations(helperFunctions.getExtractedCombinations(possibleCombinations));
			},
			getUniquePossibleCombinations: function getUniquePossibleCombinations(allCombinations) {
				var possibleCombinations = allCombinations[viewModel.selectedAttributes.length - 1]
					.concat(allCombinations[viewModel.selectedAttributes.length]);

				return possibleCombinations.reduce(function (uniquePossibleCombinations, currentCombination) {
					currentCombination.combinationValues.forEach(function (value, index) {
						if (uniquePossibleCombinations[index].indexOf(value) === -1) {
							uniquePossibleCombinations[index].push(value);
						}
					});
					return uniquePossibleCombinations;
				}, possibleCombinations[0].combinationValues.map(function () {
						return [];
				}));
			},
      getAttributeCombinationDisplayMatrix: function getAttributeCombinationDisplayMatrix(rankedCombinations) {


        var attributeValues = model.data.attributes.map(function (attribute) {
          return attribute.attributeValues.map(function (attributeValue) {
            return attributeValue.value;
          })
        })

        var selectedAttributeValues = viewModel.selectedAttributes.map(function(attribute) {
          return attribute.attributeValue;
        })

        var attributeCombinationDisplayMatrix = model.data.attributes.map(function (attribute, index) {
            return attributeValues[index].map(function(value){
              return (shouldDisplayScaledTooltips() && value === selectedAttributeValues[index]) ? selectedAttributeValues.join(COMBINATION_DELIMITER) : null;
            });
        });

        rankedCombinations[viewModel.selectedAttributes.length - 1].forEach(function (currentCombination) {
          currentCombination.combinationValues.forEach(function (value, index) {
            if (value !== viewModel.selectedAttributes[index].attributeValue) {
              attributeCombinationDisplayMatrix[index][attributeValues[index].indexOf(value)] = currentCombination.combinationString;
            }
          });
        });

        if(shouldDisplayScaledTooltips()) {
          attributeCombinationDisplayMatrix = attributeCombinationDisplayMatrix.map(function(combinationStringList, definingAttributeIndex) {
            return combinationStringList.map(function(combinationString, valueIndex) {
              if(combinationString) {
                return combinationString;
              } else {
                return viewModel.findClosestSku.findClosestChildItem({
        					attributeLabel: helperFunctions.getMinifiedString(model.data.attributes[definingAttributeIndex].attributeName),
        					attributeValue: model.data.attributes[definingAttributeIndex].attributeValues[valueIndex].value
        				});
              }
            });
          })
        }

        return attributeCombinationDisplayMatrix;
      },
			getDisabledValues: function getDisabledValues(uniqueCombinations) {
				return model.data.attributes.map(function (attribute, index) {
					return attribute.attributeValues.map(function (attributeValue) {
						return attributeValue.value;
					}).filter(function (combo) {
						return uniqueCombinations[index].indexOf(combo) < 0;
					});
				});
			},
			disableAttributes: function disableAttributes(displayData, attributesToDisable) {
				displayData.definingAttributes.forEach(function (definingAttribute, attributeIndex) {
					definingAttribute.attributes.forEach(function (attribute) {
            attribute.isDisabled = (attributesToDisable[attributeIndex].indexOf(attribute.attributeValue) >= 0);
					});
				});

				return displayData;
			},
      rectifyDeadlockOnDisplayData: function rectifyDeadlockOnDisplayData(displayData) {
        var deadlockRiskAttributes = [];
        var deadlockRiskCounter = 0;
				displayData.definingAttributes.forEach(function (definingAttribute) {
          var enabledAttributes = definingAttribute.attributes.filter(function (attribute) {
            return !attribute.isDisabled;
          });
          deadlockRiskAttributes.push(!definingAttribute.isDominantAttribute && enabledAttributes.length === 1);
          if(!definingAttribute.isDominantAttribute && enabledAttributes.length === 1) {
            deadlockRiskCounter++;
          }
				});
        if (deadlockRiskCounter <= 1) {
          return displayData;
        }
        displayData.definingAttributes = displayData.definingAttributes.map(function (definingAttribute, definingAttributeIndex) {
          definingAttribute.isDominantAttribute = definingAttribute.isDominantAttribute || deadlockRiskAttributes[definingAttributeIndex]
          return definingAttribute;
        })
        return displayData;
      }
		},
		findClosestSku: {
			getSelectedAttributes: function getSelectedAttributes(clickedTile) {
        if (!clickedTile) {
          return viewModel.findClosestSku.getSelectedAttributesForSdsku();
        }
				return viewModel.determineSelectedAttributes(viewModel.findClosestSku.findClosestCombination(clickedTile));
			},
      findClosestCombination: function findClosestCombination(clickedTile) {
				var lookupInformation = viewModel.findClosestSku.getInformationForLookup(clickedTile);
				var possibleCombinations = viewModel.findClosestSku.getPossibleCombinations(clickedTile, lookupInformation);
				var extractedCombinations = helperFunctions.getExtractedCombinations(possibleCombinations);
				var rankedCombinations = helperFunctions.rankCombinations(extractedCombinations);
				return viewModel.findClosestSku.getHighestRankingCombination(rankedCombinations);
			},
      findClosestChildItem: function findClosestChildItem(clickedTile) {
        var closestCombination = viewModel.findClosestSku.findClosestCombination(clickedTile);
        closestCombination = closestCombination.split(COMBINATION_DELIMITER).map(function (attribute) {
          return attribute.split(KEY_VALUE_DELIMITER)[1];
        }).join(COMBINATION_DELIMITER);
        return closestCombination;
			},
      getSelectedAttributesForSdsku: function getSelectedAttributesForSdsku() {
        var possibleCombinations = model.data.childItemsLookup.map(function(childItemLookup) {
          return childItemLookup.attributeCombination;
        })
        var extractedCombinations = helperFunctions.getExtractedCombinations(possibleCombinations);
				var rankedCombinations = helperFunctions.rankCombinations(extractedCombinations);
				var highestRankingCombination = viewModel.findClosestSku.getHighestRankingCombination(rankedCombinations);
				return viewModel.determineSelectedAttributes(highestRankingCombination);
      },
			getInformationForLookup: function getInformationForLookup(clickedTile) {
        var clickedAttributeIndex = 0;
				model.data.attributes.forEach(function (attribute, index) {
					if (attribute.attributeName === helperFunctions.getUnMinifiedString(clickedTile.attributeLabel)) {
						clickedAttributeIndex = index;
					}
				});
				return {
					shouldLookUpParent: clickedAttributeIndex > 0,
					numberOfChildLookups: model.data.attributes.length - clickedAttributeIndex - 1
				};
			},
			getPossibleCombinations: function findClosestSkuGetPossibleCombinations(clickedTile, lookupInfo) {
				var clickedTileCombinationKey = helperFunctions.getUnMinifiedString(clickedTile.attributeLabel) + KEY_VALUE_DELIMITER + helperFunctions.getUnMinifiedString(clickedTile.attributeValue)
				var possibleCombinations = [];

				if (lookupInfo.shouldLookUpParent) {
					possibleCombinations = model.data.attributeTreeLookupNodes[clickedTileCombinationKey].parents.map(function (parent) {
						return parent + COMBINATION_DELIMITER + clickedTileCombinationKey;
					});
				} else {
					possibleCombinations.push(clickedTileCombinationKey);
				}

				for (var iterator = 0; iterator < lookupInfo.numberOfChildLookups; iterator++) {
					var childCombinations = [];
					possibleCombinations.forEach(function (combination) {
						model.data.attributeTreeLookupNodes[combination].children.forEach(function (child) {
							childCombinations.push(combination + COMBINATION_DELIMITER + child);
						});
					});
					possibleCombinations = JSON.parse(JSON.stringify(childCombinations));
				}

				return possibleCombinations;
			},
			getHighestRankingCombination: function getHighestRankingCombination(rankedCombinations) {
				for (var index = model.data.attributes.length - 1; index >= 0; index--) {
					if (rankedCombinations[index].length > 0) {
						return rankedCombinations[index][0].combinationKey;
					}
				}
				return rankedCombinations[model.data.attributes.length][0].combinationKey;
			}
		},
    //TODO: this will become more robust as we introduce things like specific paint option displays and mixes between
    // tiles that switch to drop downs in overflow, evergreen tiles, evergreen dropdowns, image swatches, etc.
    getDisplayConfig : function getDisplayConfig(attribute, config) {
      var displayConfig = config || {
        standardSwatch: !!(attribute.swatch && !shouldUseSwatchCards() && !shouldUseSwatchDropdown()),
        standardTile: false,
        standardDropdown: false,
        tileWithDropdownOverflow: !attribute.swatch,
        swatchWithDropdownOverflow: !!(attribute.swatch && !shouldUseSwatchCards() && shouldUseSwatchDropdown()),
        isOverflowSection: false,
        standardCard: !!(attribute.swatch && shouldUseSwatchCards())
      };

      if(shouldUsePaintSsku() &&
        (attribute.attributeName === 'Paint Type'
        || attribute.attributeName === 'Brand Name'
        || attribute.attributeName === 'Sheen'
        || attribute.attributeName === 'Container Size')) {
        displayConfig = {
          standardSwatch: false,
          standardTile: false,
          standardDropdown: false,
          tileWithDropdownOverflow: false,
          isOverflowSection: false,
          standardCard: false,
          paintType: attribute.attributeName === 'Paint Type',
          brandName: attribute.attributeName === 'Brand Name',
          sheen : attribute.attributeName === 'Sheen',
          containerSize: attribute.attributeName === 'Container Size'
        }
      }

      return displayConfig;
		},

		updateHistoricalSkuQueue: function updateHistoricalSkuQueue(selectedAttributes, attributeCombination) {
			if (!selectedAttributes) { return; }
      if (pipCommonUtils.deepGet(pip.products.primary,'data.itemExtension.pricing')
        && (pip.products.primary.data.itemExtension.pricing.mapAboveOriginalPrice || pip.products.primary.data.itemExtension.pricing.mapAboveOriginalPrice === false)) {
          return;
      }
			var historicalSkuData = {};
			attributeCombination = helperFunctions.getMinifiedString(attributeCombination);
			historicalSkuData.attributes = selectedAttributes;
      historicalSkuData.productLabel = pip.products.primary.data.info.productLabel;
      historicalSkuData.useLabel = historicalSkuData.productLabel.length <= 75;
			historicalSkuData.image = pipMediaManager.getMedia().url_100;

			if (pipCommonUtils.deepGet(pip.products.primary,'data.itemExtension.displayPrice')) {
				historicalSkuData.price = '$' + parseFloat(pipCommonUtils.deepGet(pip.products.primary,'data.itemExtension.displayPrice')).toFixed(2);
			}

			historicalSkuData.attributeCombination = helperFunctions.getMinifiedString(historicalSkuData.attributes.map(function(attribute){return attribute.attributeValue}).join(COMBINATION_DELIMITER));

			viewModel.historicalSkuQueue.unshift(historicalSkuData);

			viewModel.historicalSkuQueue = viewModel.historicalSkuQueue.filter(function (historicalSku) {
				return historicalSku.attributeCombination !== attributeCombination;
			});
			viewModel.hasHistoricalSkuCard = true;
		},
		getDisplayData: function getDisplayData() {
			var	displayData = {
				definingAttributes: model.data.attributes.map(function (attribute, attributeIndex) {
					return {
						attributeName: attribute.attributeName,
						attributeNameMinified: helperFunctions.getMinifiedString(attribute.attributeName),
						attributeData: viewModel.selectedAttributes[attributeIndex].attributeValue,
            attributeMoreInfo: viewModel.getAttributeMoreInfoHook(attribute.attributeName),
						swatch: attribute.swatch,
            displayConfig: viewModel.getDisplayConfig(attribute),
						numberOfOptions: attribute.attributeValues.length,
						shouldDisplayDefiningAttribute: attribute.attributeValues.length > 1,
            isDominantAttribute: false,
            isAvailable: true,
						attributeIndex: attributeIndex,
						attributes: attribute.attributeValues.map(function (attributeValue) {
							return {
								attributeValue: attributeValue.value,
								attributeValueMinified: helperFunctions.getMinifiedString(attributeValue.value),
								attributeGUID: attributeValue.swatchGuid,
								selected: viewModel.selectedAttributes[attributeIndex].attributeValue === attributeValue.value,
                paintRgb: pip.experience === "paint" && pipCommonUtils.getAttributeValueByGroupAndGuid(pip, 'functional details', PAINT_RGB_GUID).split(':').join(','),
                paintImage: pip.experience === "paint" && paintImageMap.getImageForValue(helperFunctions.getMinifiedString(attributeValue.value))
							}
						}),
					}
				}).map(function(definingAttribute) {
          definingAttribute.selectedAttribute = definingAttribute.attributes.filter(function(attribute) {
            return attribute.selected;
          })[0];
          if(definingAttribute.attributeName === 'Brand Name') {
            definingAttribute.isPpgGlidden = ('PPG - Glidden' === pipCommonUtils.getAttributeValueByGroupAndGuid(pip, 'notDisplayed', PAINT_BRAND_GUID));
          }
          return definingAttribute;
        })
			};

      var dominantAttributeIndex = displayData.definingAttributes.reduce(function(dominantAttributeIndex, definingAttribute, definingAttributeIndex){
        if (dominantAttributeIndex === null && definingAttribute.shouldDisplayDefiningAttribute) {
          return definingAttributeIndex;
        } else {
          return dominantAttributeIndex;
        }
      }, null);
      if (dominantAttributeIndex !== null) {
        displayData.definingAttributes[dominantAttributeIndex].isDominantAttribute = true;
      }


			if (viewModel.selectedAttributes.length > 1) {
				return viewModel.combinatorial.getDisplayData(displayData);
			}
      if (isLookupLengthLessThanMaximum()) {
         viewModel.addMediaAndPriceForSingleAttribute(displayData);
      }

			return displayData;
		},
		checkCombination: function checkCombination(selectedAttributes) {
			var validCombination = [];
			model.data.childItemsLookup.forEach(function (item) {
				validCombination.push(item.attributeCombination);
			});
			var currentCombination = selectedAttributes.map(function (data) {
				return data.attributeValue
			}).join(COMBINATION_DELIMITER);

			return validCombination.indexOf(currentCombination) >= 0;
		},
		getSelectedAttributes: function getSelectedAttributes(selectedAttributes, clickedTile) {
			if (!viewModel.checkCombination(selectedAttributes)) {
        selectedAttributes = viewModel.findClosestSku.getSelectedAttributes(clickedTile);
			}
			return selectedAttributes;
		},
		getProductInformation: function getProductInformation() {
			var productInformation = {};
			var currentCombination = viewModel.selectedAttributes.map(function (data) {
				return data.attributeValue
			}).join(COMBINATION_DELIMITER);
			model.data.childItemsLookup.forEach(function (childItem) {
				if (childItem.attributeCombination === currentCombination) {
					productInformation.itemId = childItem.itemId;
					productInformation.canonicalUrl = childItem.canonicalUrl;
          productInformation.isAvailable = shouldDisplayInventory() ? childItem.isAvailable : true;
				}
			});
			return productInformation;
		},
		updateOverlayPrice: function updateOverlayPrice() {
			viewModel.set.overlayPrice(null);
			view.updateDom.overlayPrice();
			viewModel.getPrice().done(function (priceData) {
				viewModel.set.overlayPrice(priceData.pricingList[0].finalPrice);
				view.updateDom.overlayPrice();
			}).fail(function (e) {
				if (pip.debugMode) {
					console.error('SSKU Overlay Pricing Call Error', e);
				}
			});
		},
		getPrice: function getPrice() {
			return $.ajax({
				url: ('/p/svcs/getPricing/' + viewModel.selectedProductInformation.itemId),
				timeout: 10000
			});
		},
    sdsku: {
      displayData: {},
      selectedData: null,
      getSelectedData: function getSdskuSelectedData(selectedValue) {
        var selectedData = viewModel.sdsku.displayData.attributeValues.filter(function(attribute) {
            return attribute.value === selectedValue
         })

         return selectedData.length && selectedData[0];
      },
      setSelectedData: function setSelectedData(selectedData) {
        viewModel.sdsku.selectedData = selectedData;
      },
      getAnalogousSelectedAttributesForSdsku: function getAnalogousSelectedAttributesForSdsku(selectedAttributesFromSdsku, currentlySelectedAttributes) {

        var currentlySelectedAttributeLabels = currentlySelectedAttributes.map(function(attribute) {
          return attribute.attributeLabel;
        });

        var analogousSelectedAttributes = currentlySelectedAttributes.map(function(selectedAttribute) {
          return {
            attributeLabel: selectedAttribute.attributeLabel,
            attributeLabelMinified: selectedAttribute.attributeLabelMinified,
            attributeValue: 'UNDEFINED'
          }
        });

        selectedAttributesFromSdsku.forEach(function (attribute, index) {
          if (currentlySelectedAttributeLabels.indexOf(attribute.attributeLabel) > -1) {
            analogousSelectedAttributes[currentlySelectedAttributeLabels.indexOf(attribute.attributeLabel)].attributeValue = selectedAttributesFromSdsku[index].attributeValue;
          }
        });

        return analogousSelectedAttributes;
      },
      getCanonicalURL: function getCanonicalURL() {
        return $.ajax({
          url: viewModel.sdsku.selectedData.superSkuUrl,
          type: 'GET'
        });
      },
      isSdskuDisplayable: function isSdskuDisplayable() {
        return !!(model.data.sdsku
          && model.data.sdsku.attributes
          && model.data.sdsku.attributes[0]
          && model.data.sdsku.attributes[0].attributeName
          && model.data.sdsku.attributes[0].attributeValues
					&& model.data.sdsku.attributes[0].attributeValues.length > 1)
      },
    },
		init: function initViewModel() {
      viewModel.isPaint = pip.experience === "paint";
			viewModel.set.selectedProductInformation({ itemId: pip.products.primary.data.itemId, canonicalUrl: pip.products.primary.data.canonicalUrl });
      viewModel.set.selectedAttributes(viewModel.determineSelectedAttributes());
			viewModel.set.displayData(viewModel.getDisplayData());
      viewModel.initScrollStates();

      if (viewModel.sdsku.isSdskuDisplayable()) {
        $.extend(true, viewModel.sdsku.displayData, model.data.sdsku.attributes[0]);
      }
		}
	}

	var model = {
		data: {},
		createLookupNodes: function createLookupNodes(data) {
			var dataWithLookups = {
				sdsku: data.superDuperSku || {},
				attributes: data.attributes,
				childItemsLookup: data.childItemsLookup,
				attributeTreeLookupNodes: {}
			}

			if (data.attributeHierarchy && data.attributeHierarchy.attributeTreeLookup) {
				data.attributeHierarchy.attributeTreeLookup.forEach(function (tile) {
					dataWithLookups.attributeTreeLookupNodes[tile.combinationKey] = tile;
				});
			}
			return dataWithLookups;
		},
    augmentChildItemsLookup: function augmentChildItemsLookup(mediaAndPriceData) {
      model.data.childItemsLookup = model.data.childItemsLookup.map(function (childItem) {
        var matchedItems = mediaAndPriceData.filter(function (product) {
            return product.itemId === childItem.itemId;
        });

        if (matchedItems) {
          childItem.image = matchedItems[0].imageLocation;
          childItem.pricing = helperFunctions.processPrice(matchedItems[0].priceDetail);
          if(shouldDisplayInventory()) {
            childItem.inventory = helperFunctions.processInventory(matchedItems[0].onlineInventory, matchedItems[0].storeInventory);
            childItem.isAvailable = childItem.inventory.isAvailable;
          }
          if(shouldDisplayScaledTooltips()){
            childItem.combinationDetails = childItem.attributeCombination.split(COMBINATION_DELIMITER).map(function(attributeValue, attributeIndex){
              return {
                attributeName: model.data.attributes[attributeIndex].attributeName,
                attributeValue: attributeValue,
                useAttributeName: (!model.data.attributes[attributeIndex].swatch && attributeValue.length < 5)
              }
            });
          }

        }

        return childItem;
      })
    },
    removeAttributeMismatchFromChildItemsLookup: function removeAttributeMismatchFromChildItemsLookup() {
      var attributeCount = model.data.attributes.length;
      model.data.childItemsLookup = model.data.childItemsLookup.filter(function(childItem){
        return childItem.attributeCombination.split(COMBINATION_DELIMITER).length === attributeCount;
      })
    },
    getMediaAndPrice: function getMediaAndPrice() {
      var skuStringList = model.data.childItemsLookup.map(function(childItem) {
        return childItem.itemId;
      }).join(",");

      if (shouldDisplayInventory()) {
        return $.ajax({
          url: '/p/svcs/getMediaPriceAndInventory/' + skuStringList,
          timeout: 10000
        })
      }
      return $.ajax({
        url: '/p/svcs/getMediaAndPrice/' + skuStringList,
        timeout: 10000
      })
    },
		requestSskuData: function requestSskuData() {
			if (pip.products && pip.products.primary && pip.products.primary.data && pip.products.primary.data.productId) {
				var parentID = pip.products.primary.data.productId;
				return $.ajax({
					url: '/p/svcs/getMetadata/' + parentID,
					timeout: 10000
				})
			}
		},
		init: function initModel(response) {
			model.data = model.createLookupNodes(response);
		}
	}
	var helperFunctions = {
    redirectUrl : function redirectUrl(canonicalURL) {
      if (typeof (canonicalURL) !== 'string') {return;}

      window.location.href = canonicalURL;
    },
    sdskuVariantPersist: function sdskuVariantPersist(selectedAttributes) {

      selectedAttributes = viewModel.sdsku.getAnalogousSelectedAttributesForSdsku(selectedAttributes, viewModel.determineSelectedAttributes());
      viewModel.set.jumpedState(!viewModel.checkCombination(selectedAttributes));
      viewModel.set.impossibleState(false);
      viewModel.set.selectedAttributes(viewModel.getSelectedAttributes(selectedAttributes));
      viewModel.set.selectedProductInformation(viewModel.getProductInformation());
      if(!viewModel.jumpedState && !viewModel.impossibleState) {
        viewModel.set.unavailableState(!viewModel.selectedProductInformation.isAvailable);
      }
      viewModel.set.displayData(viewModel.getDisplayData());
		  view.updateDom.mainWrapper();
      view.updateDom.adjustSectionsForOverflow();
      helperFunctions.getSskuProductPage(true);
    },
    getSdskuProductPage: function getSdskuProductPage(canonicalUrl) {
      if (!canonicalUrl) {return;}
      initialized = false;
      helperFunctions.updatePipProductDataForSdksku(helperFunctions.getSkuFromSdskuUrl(canonicalUrl), viewModel.selectedAttributes);
		},
    //TODO: Our service upstream should provide this instead of having us do this.
    getSkuFromSdskuUrl: function getSkuFromSdskuUrl(url) {
      urlChunks = url.split('/');
      return urlChunks[urlChunks.length - 1];
    },

		getSskuProductPage: function getSskuProductPage(originatedFromSdsku) {

			var selectedProductInformation = viewModel.selectedProductInformation;
			if (!selectedProductInformation
        || !selectedProductInformation.itemId
        || !selectedProductInformation.canonicalUrl
        || (selectedProductInformation.itemId === pip.products.primary.data.itemId && !originatedFromSdsku)
      ) {
        return;
      }
      view.updateDom.toggleSpinnerOverlay();
			$.ajax({
				url: selectedProductInformation.canonicalUrl + window.location.search
			}).done(function (response) {
				var pipContainer = document.createElement('div');
				pipContainer.innerHTML = response;
				$(view.selectors.pip).html($(pipContainer).find(view.selectors.pip).html());
				view.init();
        paintModals.init();
				helperFunctions.updatePipPrice(selectedProductInformation.itemId);
				helperFunctions.updatePipProductData(selectedProductInformation.itemId, originatedFromSdsku);
        view.updateDom.toggleSpinnerOverlay();
			});
		},
		createSelectedState: function createSelectedState(clickedTile) {
			var selectedAttributes = JSON.parse(JSON.stringify(viewModel.selectedAttributes));
			selectedAttributes.forEach(function (attribute) {
				if (attribute.attributeLabelMinified === clickedTile.attributeLabel) {
					attribute.attributeValue = clickedTile.attributeValue;
				}
			});
			return selectedAttributes;
		},
		updatePipProductData: function updatePipProductData(itemId, originatedFromSdsku) {
			window.localizeAndLoadPriceAndLoadModelAndLoadPipBundle(itemId);
			window.pipModelRequest.then(function (data) {
          data.originatedFromSdsku = originatedFromSdsku;
			    pipEvents.ssku.sskuChange.trigger(data);
			});
		},
    updatePipProductDataForSdksku: function updatePipProductDataForSdksku(itemId, sdskuSelectedAttributes) {
			window.localizeAndLoadPriceAndLoadModelAndLoadPipBundle(itemId);
			window.pipModelRequest.then(function (data) {
        data.sdskuSelectedAttributes = sdskuSelectedAttributes;
        pipEvents.ssku.sdskuChange.trigger(data);
			});
		},
		updatePipPrice: function updatePipPrice(itemId) {
			if (pip.features.clientPriceLoadingEnabled
				&& typeof window.addPriceToPage === 'function') {
				window.addPriceToPage(itemId);
			}
		},
		getMinifiedString: function getMinifiedString(data) {
			return data.replace(/ |;/gi, "_");
		},
		getUnMinifiedString: function getUnMinifiedString(data) {
			return data.toString().replace(/_/gi, ' ');
		},
		getExtractedCombinations: function getExtractedCombinations(combinations) {
			return combinations.map(function (combination) {
				return {
					combinationValues: combination.split(COMBINATION_DELIMITER).map(function (attribute) {
						return attribute.split(KEY_VALUE_DELIMITER)[1];
					}), combinationKey: combination,
          combinationString: combination.split(COMBINATION_DELIMITER).map(function (attribute) {
            return attribute.split(KEY_VALUE_DELIMITER)[1];
          }).join(COMBINATION_DELIMITER)
				};
			});
		},
		rankCombinations: function rankCombinations(combinationsToRank) {
			var rankedCombinations = [];
			for (var iterator = 0; iterator <= viewModel.selectedAttributes.length; iterator++) {
				rankedCombinations.push([]);
			}
			var currentlySelected = viewModel.selectedAttributes.map(function (attribute) {
				return attribute.attributeValue;
			});
			return combinationsToRank.reduce(function (rankedCombinations, combination) {
				var rank = 0;
				combination.combinationValues.forEach(function (node, index) {
					if (node === currentlySelected[index]) {
						rank++;
					}
				});
				rankedCombinations[rank].push(combination);
				return rankedCombinations;
			}, rankedCombinations);
		},
    processPrice: function processPrice(pricing) {

      if (!pricing || !pricing.originalPrice) {
        return {message: 'Click Swatch to View Price'};
      }
      var priceDisplayData = {};
      var rawPrice = "";

      if (pricing.mapPrice || pricing.strikeThruMapPrice) {
        priceDisplayData.message =  "See Price in Cart";
        rawPrice = pricing.originalPrice.price;
      } else {
        rawPrice = pricing.finalPrice ? pricing.finalPrice.price: pricing.originalPrice.price;
      }

      priceDisplayData.isSpecialPrice = pricing.specialPrice.price < pricing.originalPrice.price;
      priceDisplayData.price = pipCommonUtils.pricing.formatPrice(rawPrice);
      priceDisplayData.shouldHidePriceForMap = !!pricing.mapPrice;
      priceDisplayData.strikeThroughPriceForMap = !!pricing.strikeThruMapPrice;

      return priceDisplayData;
    },
    // TODO: this will end up providing more inventory info for tooltips.
    processInventory: function processInventory(onlineInventory, storeInventory) {
      return {
        isAvailable: (onlineInventory.enableItem || storeInventory.enableItem)
      }
    }
	}

	var initialized = false;


  var shouldDisplayHistoricalCards = function shouldDisplayHistoricalCards() {
    return !!(pip.features.sskuHistoryCardsEnabled && !viewModel.sdsku.isSdskuDisplayable())
  }

  var shouldDisplayTooltips = function shouldDisplayTooltips() {
    return !!((isLookupLengthLessThanMaximum() && hasSwatchOnFirstAttribute())
      || shouldDisplayScaledTooltips());
  }

  var shouldDisplayInventory = function shouldDisplayInventory() {
    return !!(pip.features.sskuAvailabilityDisplayEnabled
      && isLookupLengthLessThanMaximum()
      && !pip.installServices.scheduleAMeasure
      && (pip.experience !== 'non_buyable_professional_services')
      && (pip.experience !== 'appliance'));
  }

  var shouldDisplayScaledTooltips = function shouldDisplayScaledTooltips() {
    return !!(isLookupLengthLessThanMaximum() && pip.features.sskuScaledHoverTooltipsEnabled);
  }

  var hasSwatchOnFirstAttribute = function hasSwatchOnFirstAttribute() {
    return !!(model
      && model.data.attributes
      && model.data.attributes[0]
      && model.data.attributes[0].swatch
    );
  }

  var hasOnlyOneAttribute = function hasOnlyOneAttribute() {
    return !!(model
      && model.data
      && model.data.attributes
      && model.data.attributes.length === 1
    );
  }

  var isKitchenOrBathFaucetsItem = function isKitchenOrBathFaucetsItem() {
    return !!(pip.products.primary.data
      && pip.products.primary.data.itemExtension
      && pip.products.primary.data.itemExtension.kitchenOrBathFaucetsItem
    );
  }

  var isLookupLengthLessThanMaximum = function isLookupLengthLessThanMaximum() {
    return !!(model
      && model.data
      && model.data.childItemsLookup
      && model.data.childItemsLookup.length <= MAXIMUM_COMBINATIONS_FOR_PRICE_ENDPOINT);
  }

  var shouldUseSwatchCards = function shouldUseSwatchCards() {
    return !!(pip.platform === 'MOBILE'
      && pip.features.sskuSwatchCardsEnabled
      && isLookupLengthLessThanMaximum()
      && hasSwatchOnFirstAttribute()
      && (hasOnlyOneAttribute() || pip.features.sskuScaledHoverTooltipsEnabled)
    );
  }

  var shouldUseSwatchDropdown = function shouldUseSwatchDropdown() {
    return !!(pip.features.sskuSwatchdownEnabled);
  }

  var shouldUsePaintSsku = function shouldUsePaintSsku() {
    return !!(pip.features.paintSskuMigrationEnabled && pip.experience === 'paint');
  }

  var init = function init(selectedAttributesFromSdsku) {
    if (pip.superSkuItem) {
      if (!initialized) {
        if(!selectedAttributesFromSdsku) {
          $(window.document.body).append(view.templates.inline.configurableDisplay.paint.spinnerOverlay);
        }
        model.requestSskuData().done(function (response) {
          model.init(response);
          model.removeAttributeMismatchFromChildItemsLookup();

          /* Workwear Features */
          workwear.init(model.data.attributes);
          viewModel.attributeInjector = workwear.getAttributeInjector();
          viewModel.init();
          view.init();
          paintModals.init();
          initialized = true;
          pipEvents.ssku.sskuMetaDataLoaded.trigger();
          if (selectedAttributesFromSdsku) {
            helperFunctions.sdskuVariantPersist(selectedAttributesFromSdsku);
          }
          if (shouldDisplayInventory() || shouldDisplayTooltips() || shouldUseSwatchCards()) {
            model.getMediaAndPrice().done(function (mediaAndPriceData) {
              model.augmentChildItemsLookup(mediaAndPriceData.productDetails);
              viewModel.set.displayData(viewModel.getDisplayData());
              view.updateDom.mainWrapper();
              if(shouldUseSwatchCards()) {
                view.handleLoadingImages();
              }
              view.updateDom.restorePreviousScrollState();
              view.updateDom.adjustSectionsForOverflow();
              view.updateDom.saveCurrentScrollState();
              if(shouldDisplayTooltips()){
                view.createTooltips();
              }
            });
          }
        }).fail(function (e) {
          e.status >= 500 ? view.updateDom.loadingError() : view.updateDom.removeSsku();
        });
      }
    }
  };

	return {
		init: init,
		view: view,
		viewModel: viewModel,
		model: model,
		helperFunctions: helperFunctions
	}
});

}.call(window));